export const ptBRReports = {
  pageTitle: 'Relatorios',
  tabTrends: 'Tendencias',
  tabCategories: 'Categorias',
  tabIncome: 'Receitas vs Despesas',
  allAccounts: 'Todas as Contas',
  noData: 'Nenhum dado para este mes',
  loading: 'Carregando...',
  summaryTotalPaid: 'Total Pago',
  summaryTotalPending: 'Total Pendente',
  summaryTotalIncome: 'Total Receitas',
  summaryTotalExpenses: 'Total Despesas',
  categoryTotal: 'Total por Categoria',
  categoryDrillBack: 'Voltar',
  categoryNoSubcategories: 'Sem subcategorias',
  categoryExpensesEmpty: 'Nenhuma despesa nesta categoria',
  expenseDate: 'Data',
  expenseDescription: 'Descricao',
  expenseAmount: 'Valor',
  expenseAccount: 'Conta',
  expensePaid: 'Pago',
  expensePending: 'Pendente',
  trendsHeading: 'Tendencias de Gastos',
  categoryHeading: 'Gastos por Categoria',
  incomeHeading: 'Receitas vs Despesas',
  export: {
    button: 'Exportar',
    csvMonth: 'CSV (este mes)',
    downloading: 'Exportando...',
    success: 'Exportacao concluida',
    error: 'Falha ao exportar',
  },
} as const;
